import { Box } from "@mui/material";
import { LoadingIndicator } from "ots-components-library";
import React from "react";

const Loading: React.FC = () => {
  return (
    <Box
      display="flex"
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      <LoadingIndicator variant="page" />
    </Box>
  );
};

export default Loading;
